<template>
  <v-card
    class="overflow-hidden"
    flat
  >
    <v-app-bar
      absolute
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
      class="pa-2"
    >
      <!-- Selecionar Todos -->
      <v-checkbox
        v-show="treeview.length > 0"
        v-model="value.todos"
        :color="cor"
        class="ml-4"
      >
        <template v-slot:label>
          <v-tooltip top>
            <template v-slot:activator="{ on: onTooltip }">
              <span v-on="{ ...onTooltip }">Selecionar Todos</span>
            </template>
            <span>Clique para selecionar todos</span>
          </v-tooltip>
        </template>
      </v-checkbox>

      <!-- Expandir -->
      <v-switch
        v-show="treeview.length > 0 && !value.resumir"
        v-model="value.expandir"
        :color="cor"
        class="ml-4"
        dense
      >
        <template v-slot:label>
          <v-tooltip top>
            <template v-slot:activator="{ on: onTooltip }">
              <span v-on="{ ...onTooltip }">Expandir Lista</span>
            </template>
            <span>Clique para expandir ou recolher os itens da lista</span>
          </v-tooltip>
        </template>
      </v-switch>

      <!-- Espaço para adicionar botões, campos, ect -->
      <slot name="toolbar" />

      <v-spacer />

      <!-- Pesquisar -->
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-text-field
            v-show="treeview.length > 0"
            v-model="value.search"
            label="Pesquisar"
            placeholder="Digite para pesquisar..."
            prepend-icon="search"
            :color="cor"
            class="ml-4"
            clearable
            @input="value.expandir = true"
            v-on="{ ...onTooltip }"
          />
        </template>
        <span>Digite para pesquisar na lista</span>
      </v-tooltip>
    </v-app-bar>

    <!-- Visualização -->
    <v-sheet
      id="scrolling-techniques-7"
      class="overflow-y-auto mt-12"
      max-height="600"
    >
      <v-container style="height: 400px">
        <v-treeview
          ref="treeview"
          v-model="value.selecionado"
          :items="treeview"
          item-children="filhos"
          :open-all="value.expandir"
          :search="value.search"
          :filter="filter"
          :selection-type="value.tipo"
          :selected-color="cor"
          :color="cor"
          dense
          selectable
          return-object
        >
          <template v-slot:label="{ item }">
            {{ item.nome }}
            <!-- Botão para selecionar todos os filhos -->
            <v-tooltip v-if="isTodosOsFilhosSelecionados(item)" right>
              <template v-slot:activator="{ on: onTooltip }">
                <v-btn
                  color="secondary"
                  class="text-capitalize"
                  text
                  @click="selecionarFilhos(item)"
                  v-on="{ ...onTooltip }"
                >
                  <v-icon class="mr-2">library_add_check</v-icon>
                </v-btn>
              </template>
              <span>Clique para remover a seleção</span>
            </v-tooltip>
            <v-tooltip v-else right>
              <template v-slot:activator="{ on: onTooltip }">
                <v-btn
                  color="grey"
                  class="text-capitalize"
                  text
                  @click="selecionarFilhos(item)"
                  v-on="{ ...onTooltip }"
                >
                  <v-icon class="mr-2">queue</v-icon>
                </v-btn>
              </template>
              <span>Clique para selecionar todos abaixo</span>
            </v-tooltip>
          </template>
        </v-treeview>
      </v-container>
    </v-sheet>
  </v-card>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'AppTreeview',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        selecionado: [],
        agruparPor: '',
        expandir: false,
        todos: false,
        resumir: false,
        search: '',
        tipo: 'independent',
      }),
    },
    nos: {
      type: Array,
      required: true,
      default: () => [],
    },
    lista: {
      type: Array,
      required: true,
      default: () => [],
    },
    cor: {
      type: String,
      required: false,
      default: 'secondary',
    },
  },

  computed: {
    treeview() {
      const treeveiw = this.nos.map((n) => this.getArvore(n));
      this.sortArvore({ filhos: treeveiw });
      return treeveiw;
    },
    nosEFilhos() {
      return _.groupBy(this.lista, this.value.agruparPor);
    },
    // Correção para fazer o treeview selecionar todos do nó selecionado até a última folha
    _treeview() {
      const clonar = (no, pai) => {
        const clone = { ...no };
        delete clone.filhos;
        if (pai) {
          clone.pai = pai;
        }
        return clone;
      };
      const addNos = (arvore, pai) => {
        const nos = arvore.reduce((acumulador, no) => {
          acumulador.push(clonar(no, pai));
          if (no.filhos) {
            acumulador.push(addNos(no.filhos, no.id));
          }
          return acumulador;
        }, []);
        return nos.flat();
      };

      return addNos(this.treeview).reduce((acumulador, no) => {
        acumulador[no.id] = no;
        return acumulador;
      }, {});
    },
    _selecionado() {
      const proxy = {};
      const addPais = (x) => {
        const paiId = this._treeview[x.id].pai;
        if (paiId) {
          addPais(this._treeview[paiId]);
          proxy[paiId] = this._treeview[paiId];
        }
      };
      this.value.selecionado.forEach((no) => {
        addPais(no);
        proxy[no.id] = no;
      });
      return Object.values(proxy);
    },
    filter() {
      return (item, search, textKey) => this.removerAcentos(item[textKey].toLowerCase())
        .indexOf(this.removerAcentos(search).toLowerCase()) > -1;
    },
  },

  watch: {
    'value.todos': function () {
      this.selecionarTodos();
    },
    'value.expandir': function (value) {
      this.$refs.treeview.updateAll(value);
    },
    'value.selecionado': function () {
      this.$emit('return', this.value.tipo === 'independent' ? this.value.selecionado : this._selecionado);
    },
  },

  methods: {
    getArvore(no) {
      const filhos = this.nosEFilhos[no.id];
      const isNoRaiz = Boolean(this.nos.find((n) => n.id === no.id));
      no.filhos = filhos || [];
      if (!this.value.resumir && no && no.filhos.length > 0) {
        return {
          id: no.id,
          isNoRaiz,
          nome: no.nome,
          name: no.nome,
          filhos: no.filhos.map((s) => this.getArvore(s)),
        };
      }
      return {
        id: no.id,
        isNoRaiz,
        nome: no.nome,
        name: no.nome,
        filhos: [],
      };
    },
    sortArvore(arvore) {
      if (arvore.filhos) {
        arvore.filhos.sort((a, b) => a.nome.localeCompare(b.nome));
        arvore.filhos.forEach((f) => this.sortArvore(f));
      }
    },
    getFilhos(no, acumulador = []) {
      if (no) {
        acumulador.push(no);
        if (no && no.filhos.length > 0) {
          no.filhos.forEach((f) => this.getFilhos(f, acumulador));
        }
      }
      return acumulador;
    },
    selecionarFilhos(no) {
      const filhos = this.getFilhos(no);
      this.$nextTick(() => {
        if (this.isTodosOsFilhosSelecionados(no)) {
          this.value.selecionado = this.value.selecionado.filter((s) => !filhos.some((f) => f.id === s.id));
        } else {
          this.value.selecionado = this.value.selecionado.filter((s) => !filhos.some((f) => f.id === s.id));
          this.value.selecionado.push(...filhos);
        }
      });
    },
    selecionarTodos() {
      this.$nextTick(() => {
        if (this.value.todos) {
          this.value.selecionado = [...this.lista];
        } else {
          this.value.selecionado = [];
        }
      });
    },
    isTodosOsFilhosSelecionados(no) {
      const filhos = this.getFilhos(no);
      const filhosSelecionados = filhos.filter((f) => this.value.selecionado.some((s) => s.id === f.id));
      return filhosSelecionados.length === filhos.length;
    },
    removerAcentos(string) {
      return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
  },
};
</script>
